export const optionSeparatorProps = {
  borderTop: '1px solid #ddd',
  height: '1px',
  lineHeight: 0,
  padding: 0,
  cursor: 'default',
  marginLeft: '20px',
}

export const otherVersionProps = {
  fontWeight: '700',
  color: '#888',
  cursor: 'default',
  marginLeft: '10px',
  fontSize: '12px',
}

export const getOptionTitleStyle = (isChild, hideOverflow) => ({
  ...(hideOverflow
    ? {
        whiteSpace: 'nowrap',
      }
    : {
        display: '-webkit-box',
        WebkitLineClamp: 2, // Sets the max number of lines to 2
        WebkitBoxOrient: 'vertical',
        fontWeight: isChild ? '500' : '600',
      }),
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  marginLeft: isChild ? '10px' : '0px',
  fontSize: isChild ? '12px' : '14px',
})
